import React from "react";
import { FaEye } from "react-icons/fa";

// Accepts: visible (bool), billing (object), onClose (function)
function BillingView({ visible, billing, onClose }) {
  if (!visible || !billing) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        background: "rgba(0,0,0,0.2)",
        zIndex: 1050,
      }} 
      tabIndex={-1}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: 500 }}>
        <div className="modal-content p-3">
          <div className="modal-header border-0 pb-0">
            <h4 className="modal-title fw-bold">
              <FaEye className="me-2" /> View Plan Features
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body" style={{ paddingTop: 0 }}>
            {/* Basic Information */}
            <div className="mb-2">
              <div className="fw-bold">Basic Information</div>
              <div style={{ color: "#838383", fontSize: "15px" }}>
                Invoice No. : {billing.invoiceNumber}
                <br />
                {billing.company}
              </div>
            </div>
            <hr />
            {/* Payment Information */}
            <div className="mb-2">
              <div className="fw-bold">Payment Information</div>
              <div className="row">
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    Payment Date
                  </div>
                  <div>
                    <span role="img" aria-label="calendar">🗓️</span> {billing.paymentDate}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    Next Payment Date
                  </div>
                  <div>
                    <span role="img" aria-label="calendar">🗓️</span> {billing.nextPaymentDate}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* Business Information */}
            <div className="mb-2">
              <div className="fw-bold">Business Information</div>
              <div className="row">
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    GST Number
                  </div>
                  <div>
                    <span role="img" aria-label="gst">📄</span> {billing.gstNumber}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    Transaction Id
                  </div>
                  <div>
                    <span role="img" aria-label="tid">📄</span> {billing.transactionId}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* Plan & Package Information */}
            <div className="mb-2">
              <div className="fw-bold">Plan & Package Information</div>
              <div className="row">
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    Package Types
                  </div>
                  <div>
                    <span role="img" aria-label="plan">📦</span> {billing.package}
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ color: "#838383", fontSize: "15px" }}>
                    Amount
                  </div>
                  <div>
                    <span role="img" aria-label="amount">💰</span> {billing.amount}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* Quick Information */}
            <div className="mb-2">
              <div className="fw-bold">Quick Information</div>
              <div className="row gx-2">
                <div className="col-6">
                  <div style={{
                    background: "#E5F7ED",
                    borderRadius: 8,
                    padding: 12,
                  }}>
                    <div style={{ color: "#7B8C70", fontSize: "13px" }}>User Name</div>
                    <div style={{ color: "#22C55E", fontWeight: "bold", fontSize: "16px" }}>
                      {billing.userName || "Nirav Vekariya"}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div style={{
                    background: "#EEF2FF",
                    borderRadius: 8,
                    padding: 12,
                  }}>
                    <div style={{ color: "#7B8C70", fontSize: "13px" }}>Company</div>
                    <div style={{ color: "#6366F1", fontWeight: "bold", fontSize: "16px" }}>
                      {billing.company}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Cancel Button */}
            <div className="d-flex justify-content-end mt-4">
              <button type="button" className="btn btn-light" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BillingView;